import { BsFilter, BsSearch } from 'react-icons/bs'

import styled from 'styled-components'

const TabTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export function FiltersTitle() {
  return (
    <TabTitleContainer id="tab-filters">
      Filters <BsFilter />
    </TabTitleContainer>
  )
}

export function SearchTitle() {
  return (
    <TabTitleContainer id="tab-record-search">
      Record Search <BsSearch />
    </TabTitleContainer>
  )
}
